import { render, staticRenderFns } from "./ReceiveConfirmBubbles.vue?vue&type=template&id=a7613cde&scoped=true"
import script from "./ReceiveConfirmBubbles.vue?vue&type=script&lang=js"
export * from "./ReceiveConfirmBubbles.vue?vue&type=script&lang=js"
import style0 from "./ReceiveConfirmBubbles.vue?vue&type=style&index=0&id=a7613cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7613cde",
  null
  
)

export default component.exports